import type { IFeatureMap } from '../../features';
import {
  affinity,
  autoSend,
  conversation,
  drip,
  emailList,
  emailListFacebook,
  facebook,
  googleAdsSmart,
  invites,
  landingPage,
  mailrailAutoSend,
  mailrailDrip,
  mailrailSingleSend,
  mobileGeoFenceRetargeting,
  mobileGeoFencing,
  omni,
  retargeting,
  search,
  seedSegment,
  singleSend,
  smartSend,
  trackedLink,
} from '../../types/campaigns';

export const Lite: IFeatureMap = {
  data: {
    includedKnownPeople: 'dynamic',
    // 100x Known People
    includedAnonymousPeople: 'dynamic',
    // 100k Known People actions (monthly)
    trackedActivities: 'dynamic',
    emailsSent: 50000,
    emailSendOveragePricingPerEmail: 0.02,
    standardAudienceData: true,
    audienceSegmentation: true,
    dataImporter: true,
    customDataFields: 10,
    conversionPixels: Infinity,
    implementationsPageVisible: false,
    zapier: 0,
    directIntegrations: 0,
    iMISDirectIntegration: false,
    blackbaudDirectIntegration: false,
  },
  ads: {
    [retargeting]: true,
    [mobileGeoFencing]: 0,
    [mobileGeoFenceRetargeting]: 0,
    [facebook]: false,
    [emailListFacebook]: false,
    [emailList]: Infinity,
    [search]: false,
    [seedSegment]: false,
    [affinity]: false,
    [googleAdsSmart]: false,
    [omni]: true,
  },
  email: {
    [singleSend]: true,
    [smartSend]: true,
    [autoSend]: true,
    [drip]: false,
    [mailrailSingleSend]: true,
    [mailrailAutoSend]: true,
    [mailrailDrip]: false,
    domainsAuthenticated: 3,
  },
  conversations: {
    [conversation]: true,
  },
  creatives: {
    // Monthly
    adBannerCreator: 10,
  },
  invites: {
    [invites]: false,
    partnerManager: false,
    partnersPerProject: 0,
    partnerMarketingCollateralBuilder: false,
    partnerDashboards: 0,
  },
  monetization: {
    sponsoredRetargetingCampaigns: false,
    liveSponsorReports: false,
  },
  other: {
    flights: true,
    forms: true,
    [trackedLink]: false,
    [landingPage]: true,
    dedicatedIPs: 0,
    users: 5,
    childAccountsWithSwitcher: 0,
    childAccountSharingWithPermissionManagement: 0,
    customUserRolesAndPermissionsManagement: false,
  },
  trainingAndSupport: {
    liveChatSupport: true,
    dedicatedCSM: false,
    accessToHelpDeskFeathrAcademyAndFeathrLiveWebinars: true,
    dedicatedStrategicAdvisorHours: 0,
    livePhoneSupport: false,
    dataIntegrationServicesActiveWithLicense: false,
    proResourcesPageVisible: false,
    /** New accounts will have onboarding. Downgraded accounts will not. */
    inAppOnboarding: 'dynamic',
  },
};
